export default "__VITE_ASSET__1a453e66__"